import React, { useState } from 'react';
import { Play, Volume2, VolumeX } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';

const TrailerSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const { getContent } = useSiteContent();
  
  const trailerVideo = getContent('trailer_video', 'https://cdn.pixabay.com/video/2024/09/24/232549_large.mp4');
  const trailerPoster = getContent('trailer_poster', 'https://images.unsplash.com/photo-1654132497891-c092cc905379');

  const handlePlayClick = () => {
    const video = document.getElementById('gameplay-video');
    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleMuteToggle = () => {
    const video = document.getElementById('gameplay-video');
    if (video) {
      video.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <section id="trailer" className="trailer-section section-padding bg-page-bg">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-6">Experience the Combat</h2>
          <p className="body-medium text-text-secondary max-w-2xl mx-auto">
            Watch elemental powers clash in epic PvP battles
          </p>
        </div>

        <div className="trailer-wrapper">
          <div className="video-container">
            <video
              id="gameplay-video"
              className="gameplay-video"
              loop
              muted={isMuted}
              playsInline
              poster={trailerPoster}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            >
              <source
                src={trailerVideo}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            {/* Video Overlay Controls */}
            <div className="video-overlay">
              <button
                onClick={handlePlayClick}
                className="play-button"
                aria-label={isPlaying ? 'Pause video' : 'Play video'}
              >
                {!isPlaying && (
                  <div className="play-icon-wrapper">
                    <Play size={48} fill="currentColor" />
                  </div>
                )}
              </button>

              <div className="video-controls">
                <button
                  onClick={handleMuteToggle}
                  className="mute-button"
                  aria-label={isMuted ? 'Unmute video' : 'Mute video'}
                >
                  {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
                </button>
              </div>
            </div>
          </div>

          <div className="trailer-info">
            <div className="info-badge">
              <span className="caption">Official Gameplay Trailer</span>
            </div>
            <p className="body-small mt-4">
              Witness the power of elemental combat in Unreal Engine. Choose your element, master your abilities, and dominate the arena.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrailerSection;
